import { render, staticRenderFns } from "./TrainingActions.vue?vue&type=template&id=36abd480&scoped=true&"
import script from "./TrainingActions.vue?vue&type=script&lang=js&"
export * from "./TrainingActions.vue?vue&type=script&lang=js&"
import style0 from "./TrainingActions.vue?vue&type=style&index=0&id=36abd480&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36abd480",
  null
  
)

export default component.exports